<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap justify-center mb-1 mt-6">
      <template v-for="(link, p) in linksToShow" :key="p">
        <Link
          class="
            bg-white
            px-4
            py-3
            shadow-sm
            leading-4
            border
            mr-1
            rounded-lg
            hover:bg-blue-500 hover:text-white
          "
          :class="{
            'bg-blue-500 text-white': link.active,
            'rounded-l-lg': p === 0,
            'rounded-r-lg border-r': p === linksToShow.length - 1,
          }"
          :href="link.url"
          v-html="link.label"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: Array,
  },
  computed: {
    linksToShow() {
      var links = [...this.links];

      if (!this.showPrevLink) {
        links.shift();
      }

      if (!this.showNextLink) {
        links.pop();
      }

      return links;
    },
    activeLink() {
      return this.links.findIndex((link) => link.active);
    },
    showPrevLink() {
      return this.activeLink !== 1;
    },
    showNextLink() {
      return this.activeLink !== this.links.length - 2;
    },
  },
};
</script>